<!-- eslint-disable vue/html-self-closing -->
<template>
    <div>
        <v-card flat tile>
            <v-app-bar dense color="#F3F4F6" style="border-bottom: 1px solid #D2D6DB; position:fixed; width:100%; z-index:1000" hide-on-scroll>
                <v-toolbar-title class="d-flex justify-space-between flex-column flex-sm-row" style="width: 100%;">
                    <ul class="top-header-menu m-0 d-none d-sm-block">
                        <li><a class="dropdown-item" target="_blank" href="https://balady.gov.sa">{{$t('Baladi')}}</a></li>
                        <li class="dot"></li>
                        <li><a class="dropdown-item" href="https://sakani.sa" target="_blank">{{$t('Sakani')}}</a></li>
                        <li class="dot"></li>
                        <li><a class="dropdown-item" :href="`https://momah.gov.sa/${language}/branches`" target="_blank">{{$t('Municipalities')}}</a></li>
                    </ul>
                    <div>
                    <!-- shortcut to the executive dashboard, only for users granted its menu permission -->
                    <v-btn v-if="hasDashboardAccess" :to="{ name: 'dashboard' }" class="me-2 hdr-btn hdr-btn--dashboard" elevation="0" :aria-label="$t('Dashboard')">
                        <v-icon color="#384250">mdi-monitor-dashboard</v-icon>
                        <span class="hdr-btn-label">{{ $t('Dashboard') }}</span>
                    </v-btn>
                    <v-menu v-model="notificationsMenu" offset-y nudge-bottom="6" rounded="lg" content-class="hdr-menu hdr-menu--notif" :close-on-content-click="true">
                        <template v-slot:activator="{ on }">
                            <v-btn class="me-2 hdr-btn" elevation="0" v-on="on" :aria-label="$t('Notifications')">
                                <v-badge :content="messages"
                                         :value="messages"
                                         color="#dc2626"
                                         overlap
                                         class="hdr-badge">
                                    <v-icon color="#384250">
                                        mdi-bell-outline
                                    </v-icon>
                                </v-badge>
                            </v-btn>
                        </template>
                        <div class="ntf">
                            <div class="ntf-head">
                                <span class="ntf-head-ic"><v-icon small>mdi-bell-outline</v-icon></span>
                                <span class="ntf-title">{{ $t('Notifications') }}</span>
                                <span v-if="messages > 0" class="ntf-count">{{ messages }}</span>
                            </div>
                            <v-progress-linear v-if="loadingNotifications" indeterminate color="primary" height="2"></v-progress-linear>
                            <div v-if="notifications.length > 0" class="ntf-list">
                                <button v-for="item in notifications"
                                        :key="item.activityInstanceId"
                                        type="button"
                                        class="ntf-item"
                                        :class="{ 'is-unread': !item.claimed, 'is-late': item.isDelayed }"
                                        @click="openNotification(item)">
                                    <span class="ntf-bar" aria-hidden="true"></span>
                                    <div class="ntf-top">
                                        <span class="ntf-item-title">{{ item.title }}</span>
                                        <span class="ntf-ref">{{ item.referenceNumber }}</span>
                                    </div>
                                    <div class="ntf-process">{{ item.processTitle | stripProcessTitleSuffix }}</div>
                                    <!-- عنوان الطلب — absent on requests submitted before the field existed -->
                                    <div v-if="item.requestTitle" class="ntf-req">{{ item.requestTitle }}</div>
                                    <div class="ntf-meta">
                                        <v-icon x-small class="ntf-meta-ic">mdi-calendar-clock</v-icon>
                                        <span>{{ $t('DueDate') }}</span>
                                        <span class="ntf-date">{{ item.dueDate | formatDateGregorian }}</span>
                                    </div>
                                </button>
                            </div>
                            <div v-else-if="!loadingNotifications" class="ntf-empty">
                                <v-icon size="34" color="#b8c4c1">mdi-bell-check-outline</v-icon>
                                <span>{{ tr('NoNewNotifications', 'No new notifications', 'لا توجد إشعارات جديدة') }}</span>
                            </div>
                        </div>
                    </v-menu>
                    <v-menu offset-y nudge-bottom="6" rounded="lg" content-class="hdr-menu" transition="slide-y-transition">
                        <template #activator="{ attrs, on }">
                            <v-btn elevation="0" :loading="changingLanguage" v-bind="attrs" v-on="on" class="me-2 hdr-btn">
                                <v-icon color="#384250">
                                    mdi-earth
                                </v-icon>
                                {{ isArabicLanguage ? 'العربية' : 'English' }}
                            </v-btn>
                        </template>

                        <v-list class="hdr-list" dense>
                            <v-list-item class="hdr-item" :class="{ 'is-current': isArabicLanguage }" @click="!isArabicLanguage && changeLanguage('ar')">
                                <span class="hdr-item-ic"><v-icon small>mdi-translate</v-icon></span>
                                <v-list-item-title class="hdr-item-title">العربية</v-list-item-title>
                                <v-icon v-if="isArabicLanguage" small class="hdr-item-check">mdi-check</v-icon>
                            </v-list-item>
                            <v-list-item class="hdr-item" :class="{ 'is-current': !isArabicLanguage }" @click="isArabicLanguage && changeLanguage('en')">
                                <span class="hdr-item-ic"><v-icon small>mdi-translate</v-icon></span>
                                <v-list-item-title class="hdr-item-title">English</v-list-item-title>
                                <v-icon v-if="!isArabicLanguage" small class="hdr-item-check">mdi-check</v-icon>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <v-menu offset-y nudge-bottom="6" rounded="lg" content-class="hdr-menu hdr-menu--account" transition="slide-y-transition">
                        <template #activator="{ attrs, on }">
                            <v-btn elevation="0" v-bind="attrs" v-on="on" class="me-2 hdr-btn" :aria-label="$t('Profile')">
                                <v-icon color="#384250">
                                    mdi-account-circle
                                </v-icon>
                            </v-btn>
                        </template>

                        <div class="hdr-account">
                            <span class="hdr-avatar"><v-icon>mdi-account</v-icon></span>
                            <div class="hdr-account-body">
                                <span class="hdr-account-name">{{ isArabicLanguage ? loggedInUser?.fullnameAr : loggedInUser?.fullnameEn }}</span>
                                <span class="hdr-account-mail">{{ loggedInUser?.email }}</span>
                            </div>
                        </div>
                        <v-list class="hdr-list" dense>
                            <v-list-item class="hdr-item" link @click="showPasswordDialog = true">
                                <span class="hdr-item-ic"><v-icon small>mdi-lock-outline</v-icon></span>
                                <v-list-item-title class="hdr-item-title">{{ $t("ChangePassword") }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="hdr-item" link @click="showSignatureDialog = true">
                                <span class="hdr-item-ic"><v-icon small>mdi-draw-pen</v-icon></span>
                                <v-list-item-title class="hdr-item-title">{{ $t("EditSignature") }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="hdr-item" link @click="downloadGuide">
                                <span class="hdr-item-ic"><v-icon small>mdi-book-open-page-variant-outline</v-icon></span>
                                <v-list-item-title class="hdr-item-title">{{ $t("UserGuide") }}</v-list-item-title>
                            </v-list-item>
                            <div class="hdr-sep"></div>
                            <v-list-item class="hdr-item hdr-item--danger" link @click="logout()">
                                <span class="hdr-item-ic"><v-icon small>mdi-logout</v-icon></span>
                                <v-list-item-title class="hdr-item-title">{{ $t("SignOut") }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                </v-toolbar-title>
            </v-app-bar>
            <v-app-bar v-if="!scrolled" elevation="0" height="auto" dense color="#FFF" style="position:fixed; width:100%; z-index:1000; top:48px ;border-bottom: 1px solid #D2D6DB;padding:0px" hide-on-scroll>
                <v-container fluid style="padding-left:0px;padding-right:0px">
                    <v-row>
                        <!-- Burger Menu for Mobile -->
                        <v-col cols="5" class="text-start d-block d-lg-none">
                            <v-app-bar-nav-icon color="black" @click="drawer = !drawer" />
                        </v-col>

                        <!-- Logo -->
                        <v-col cols="auto" class="text-end d-flex d-lg-block justify-end" style="padding:10px 5px">
                            <v-btn text to="/" class="logolink" :style="`float:${ language == 'ar'?'right':'left' };display:inline; padding:0px;background-color:transparent !important`"><img style="height:40px;" src="../../assets/images/mh-logo-full.png" /></v-btn>
                        </v-col>
                        
                        <!-- Navigation Links (Visible on larger screens) -->
                        <v-col cols="auto" class="d-none d-lg-flex pa-0">
                            <v-row justify="center" no-gutters>
                                <template v-for="item in menus">
                                    <v-btn v-if="item.route" :key="item.id" :to="{ name: item.route }" text class="mx-2 menubtn py-7">
                                        {{ $t(item.title) }}
                                    </v-btn>

                                    <v-menu v-else :key="item.id" offset-y close-on-content-click>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" text class="mx-2 menubtn py-7">
                                                {{ $t(item.title) }}
                                                <v-icon right>mdi-chevron-down</v-icon>
                                            </v-btn>
                                        </template>

                                        <!-- Dropdown Menu Items -->
                                        <v-list>
                                            <v-list-item v-for="child in item.children"
                                                         :key="child.id"
                                                         :to="{ name: child.route, params: child.params }"
                                                         class="px-4">
                                                <v-icon size="15" color="primary" class="mr-2">
                                                    {{ isArabicLanguage ? 'mdi-subdirectory-arrow-left' : 'mdi-subdirectory-arrow-right' }}
                                                </v-icon>
                                                <v-list-item-content>
                                                    <span class="node-item-sub">{{ $t(child.title) }}</span>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </v-row>
                        </v-col>

                        <!-- Additional Logo -->
                       
                    </v-row>
                </v-container>
            </v-app-bar>
        </v-card>
        <v-app-bar v-if="scrolled" dense tile app height="auto" color="#ffffff" style="z-index:99999">
            <v-container fluid style="padding-left:0px;padding-right:0px">
                    <v-row>
                        <!-- Burger Menu for Mobile -->
                        <v-col cols="5" class="text-start d-block d-lg-none">
                            <v-app-bar-nav-icon color="black" @click="drawer = !drawer" />
                        </v-col>

                        <!-- Logo -->
                        <v-col cols="auto" class="text-end d-flex d-lg-block justify-end" style="padding:10px 5px">
                            <v-btn text to="/" class="logolink" :style="`float:${ language == 'ar'?'right':'left' };display:inline; padding:0px;background-color:transparent !important`"><img style="height:40px;" src="../../assets/images/mh-logo-full.png" /></v-btn>
                        </v-col>
                        
                        <!-- Navigation Links (Visible on larger screens) -->
                        <v-col cols="auto" class="d-none d-lg-flex pa-0">
                            <v-row justify="center" no-gutters>
                                <template v-for="item in menus">
                                    <v-btn v-if="item.route" :key="item.id" :to="{ name: item.route }" text class="mx-2 menubtn py-7">
                                        {{ $t(item.title) }}
                                    </v-btn>

                                    <v-menu v-else :key="item.id" offset-y close-on-content-click>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" text class="mx-2 menubtn py-7">
                                                {{ $t(item.title) }}
                                                <v-icon right>mdi-chevron-down</v-icon>
                                            </v-btn>
                                        </template>

                                        <!-- Dropdown Menu Items -->
                                        <v-list>
                                            <v-list-item v-for="child in item.children"
                                                         :key="child.id"
                                                         :to="{ name: child.route, params: child.params }"
                                                         class="px-4">
                                                <v-icon size="15" color="primary" class="mr-2">
                                                    {{ isArabicLanguage ? 'mdi-subdirectory-arrow-left' : 'mdi-subdirectory-arrow-right' }}
                                                </v-icon>
                                                <v-list-item-content>
                                                    <span class="node-item-sub">{{ $t(child.title) }}</span>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </v-row>
                        </v-col>

                        <!-- Additional Logo -->
                       
                    </v-row>
                </v-container>
        </v-app-bar>
        
        <!-- Sidebar Navigation Drawer -->
        <v-navigation-drawer app v-model="drawer" temporary style="z-index:99999999"
                             :right="isArabicLanguage ? true : false">
            <v-list-item class="px-2">
                <v-list-item-avatar>
                    <v-img small :src="require('@/assets/images/balady.png')" class="pa-md-4 mx-lg-auto" width="35%" alt />
                </v-list-item-avatar>

                <v-list-item-title>{{ $t("ApplicationName") }}</v-list-item-title>

                <v-btn icon
                       @click.stop="drawer = !drawer">
                    <v-icon v-if="!isArabicLanguage">mdi-chevron-left</v-icon>
                    <v-icon v-else>mdi-chevron-right</v-icon>
                </v-btn>
            </v-list-item>
            <v-divider></v-divider>


            <v-list dense>
                <template v-for="item in menus">

                    <v-list-item v-if="item.route" :key="item.id" :to="{ name: item.route }">
                        <v-list-item-icon>
                            <v-icon> {{ item.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <span class="node-item"> {{ $t(item.title) }}</span>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-group v-if="!item.route" :key="item.id" no-action color="secondary" active-class="secondary--text">
                        <template v-slot:activator>
                            <v-list-item-icon>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content v-if="item.route">
                                <b class="text-decoration-none node-item" :to="{ name: item.route }">{{ $t(item.title) }}</b>
                            </v-list-item-content>
                            <v-list-item-content v-else>
                                <span class="node-item">{{ $t(item.title) }}</span>
                            </v-list-item-content>
                        </template>

                        <v-list-item v-for="child in item.children" :key="child.id" :to="{ name: child.route, params: child.params }">
                            <v-icon size="15" color="primary" v-if="isArabicLanguage">mdi-subdirectory-arrow-left</v-icon>
                            <v-icon size="15" color="primary" v-else>mdi-subdirectory-arrow-right</v-icon>
                            <v-list-item-content>
                                <span class="node-item-sub">{{ $t(child.title) }}</span>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </template>
            </v-list>
        </v-navigation-drawer>
        <!--<v-app-bar dense tile app dark color="primary">
        <v-app-bar-nav-icon @click.stop="$emit('sidebarToggled', false)"></v-app-bar-nav-icon>

        <router-link to="/" class="white--text text-decoration-none"><v-icon>mdi-home</v-icon> <span class="hometitle">{{ $t('Home') }}</span></router-link>
        <v-spacer class="homespacer" />
        <v-menu tile left bottom rounded offset-y transition="scale-transition">
            <template v-slot:activator="{ on }">
                <v-btn small v-on="on" color="primary" elevation="0">
                    <v-badge :content="messages"
                             :value="messages"
                             color="secondary"
                             overlap>
                        <v-icon>
                            mdi-bell
                        </v-icon>
                    </v-badge>
                </v-btn>
            </template>
            <v-card tile width="300" v-if="messages > 0">
                <v-card-title class="primary--text"><h5>{{ $t('Notifications') }}</h5></v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <h4>{{ $t('Having') }} {{ $t('Count') }} <v-chip color="primary" x-small label>{{messages }}</v-chip> {{ $t('InboxText') }}</h4>
                </v-card-text>

            </v-card>
        </v-menu>
        <v-menu tile rounded="0" offset-y>
            <template #activator="{ attrs, on }">
                <v-btn elevation="0" tile color="primary" dark :loading="changingLanguage" v-bind="attrs" v-on="on">
                    <v-icon>
                        mdi-earth
                    </v-icon>
                    {{ isArabicLanguage ? 'العربية' : 'English' }}
                </v-btn>
            </template>

            <v-list tile dense color="grey lighten-4" class="pb-0">
                <template v-if="isArabicLanguage">
                    <v-list-item @click="changeLanguage('en')">
                        <v-list-item-title>
                            <h4>
                                English
                            </h4>
                        </v-list-item-title>
                    </v-list-item>
                    <v-divider />
                </template>
                <template v-else>
                    <v-list-item @click="changeLanguage('ar')">
                        <v-list-item-title>
                            <h4>
                                العربية
                            </h4>
                        </v-list-item-title>
                    </v-list-item>
                    <v-divider />
                </template>
            </v-list>
        </v-menu>

        <v-menu tile rounded="0" offset-y>
            <template #activator="{ attrs, on }">
                <v-btn elevation="0" tile color="primary" v-bind="attrs" v-on="on">
                    <v-icon large>
                        mdi-account-circle
                    </v-icon>
                </v-btn>
            </template>

            <v-list tile color="grey lighten-4" class="pb-0">
                <v-list-item class="pb-4">
                    <v-list-item-avatar>
                        <v-avatar color="primary" size="56">
                            <v-icon dark>
                                mdi-account-circle
                            </v-icon>
                        </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>
                            <h3>{{ isArabicLanguage ? loggedInUser?.fullnameAr : loggedInUser?.fullnameEn }}</h3>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ loggedInUser?.email }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider />

                <v-list-item link @click="showPasswordDialog = true">
                    <v-list-item-title>
                        <h4>
                            <v-icon dense color="dark">
                                mdi-lock
                            </v-icon>
                            {{ $t("ChangePassword") }}
                        </h4>
                    </v-list-item-title>
                </v-list-item>
                <v-divider />
    <v-list-item link @click="showSignatureDialog = true">
        <v-list-item-title>
            <h4>
                <v-icon dense color="dark">mdi-account-edit</v-icon>
                {{ $t("EditSignature") }}
            </h4>
        </v-list-item-title>
    </v-list-item>
    <v-divider />
                <v-list-item link @click="downloadGuide">
                    <v-list-item-title>
                        <h4>
                            <v-icon dense color="dark">
                                mdi-book-open-page-variant
                            </v-icon>
                            {{ $t("UserGuide") }}
                        </h4>
                    </v-list-item-title>
                </v-list-item>
                <v-divider />
                <v-list-item link @click="logout()">
                    <v-list-item-title>
                        <h4>
                            <v-icon dense color="dark">
                                mdi-power
                            </v-icon>
                            {{ $t("SignOut") }}
                        </h4>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>


    </v-app-bar>-->

        <user-signature v-if="showSignatureDialog" v-model="showSignatureDialog" />
        <user-password v-if="showPasswordDialog" v-model="showPasswordDialog" />
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { clearTranslation } from '@/plugins/i18n/index.js'
    import { connection } from '@/plugins/hub/myHubPlugin.js'
    import UsersService from '@/services/UsersService.js'
    import TasksService from '@/services/TasksService.js'

    import AttachmentsService from '@/services/AttachmentsService'
    import UserSignature from '@/components/app/user/UserSignature.vue'
    import UserPassword from '@/components/app/user/UserPassword.vue'
    import { openFile } from '@/helpers/downloader.js'

    import getMenus from '@/plugins/router/menus/menus.js'
    export default {

        components: {
            UserSignature, UserPassword
        },

        data() {
            return {
                messages: 0,
                notifications: [],
                notificationsMenu: false,
                loadingNotifications: false,
                // the badge counts every unclaimed task; the dropdown lists the first page of
                // them, which is why the chip in its header keeps showing the full count
                notificationsPageSize: 20,
                changingLanguage: false,
                showSignatureDialog: false,
                showPasswordDialog: false,
                scrolled: false,
                menus: [],
                hasDashboardAccess: false,
                drawer: false,
            }
        },

        created() {
            if (this.loggedInUser) {
                // the badge count hits a cross-database view that can take seconds — defer it
                // until the browser is idle so it never competes with the page's own requests
                const start = () => this.loadNotifications()
                if ('requestIdleCallback' in window) {
                    window.requestIdleCallback(start, { timeout: 4000 })
                } else {
                    setTimeout(start, 1500)
                }
            }
        },

        computed: {
            ...mapGetters('user', ['loggedInUser', 'language']),

            isArabicLanguage() {
                return this.language == 'ar'
            }
        },

        watch: {
            // fetched when the dropdown opens rather than on every page, and re-fetched on
            // each open so the list and the badge recover from anything the hub missed
            notificationsMenu(open) {
                if (open && this.loggedInUser) {
                    this.loadNotifications()
                    this.loadUnreadTasks()
                }
            }
        },

        mounted() {
            UsersService.listCurrentUserPermissions().then((res) => {
                if (res.data) {
                    this.filterMenu(res.data)
                }
            }).catch(() => {
                this.$root.$notification(this.$t('ErrorOccurred'), 'error')
            }).finally(() => {
                this.loading = false
            })
            this.currentLanguage = this.language

            connection.on('ReceiveChanges', () => {
                this.messages = this.messages + 1
                if (this.notificationsMenu) {
                    this.loadUnreadTasks()
                }
            })

            // re-read rather than -1: the hub also fires for claims this tab already accounted
            // for optimistically, and a blind decrement drifts the badge below the real count
            connection.on('ReceiveClaim', () => {
                this.loadNotifications()
            })
            this.$root.$on('task-claimed', this.loadNotifications)
            window.addEventListener('scroll', this.onScroll)
        },

        beforeDestroy() {
            this.$root.$off('task-claimed', this.loadNotifications)
            window.removeEventListener('scroll', this.onScroll)
        },

        methods: {
            filterMenu(menuItems) {
                // the dashboard lives in the top bar, not in the menu list, so its grant is read directly
                this.hasDashboardAccess = menuItems.some(x => x.name === 'Dashboard' && x.hasAccess)

                let menuList = getMenus()
                let rootElements = menuList.filter(x => x.children == null)
                let nodeElements = menuList.filter(x => x.children != null)

                for (var i = 0; i < menuItems.length; i++) {
                    let currentItem = menuItems[i]
                    if (currentItem.hasAccess) {
                        let menuItem = rootElements.filter(r => r.id == currentItem.name)[0]
                        if (menuItem) {
                            this.menus.push(menuItem)
                        }
                    }
                }

                for (var j = 0; j < nodeElements.length; j++) {
                    let nodeElement = nodeElements[j]
                    let childsArray = []
                    if (nodeElement) {
                        for (var k = 0; k < nodeElement.children.length; k++) {
                            let childElement = nodeElement.children[k]
                            if (menuItems.filter(x => x.name == childElement.id).length > 0) {
                                childsArray.push(childElement)
                            }
                        }
                        if (childsArray.length > 0) {
                            nodeElement.children = childsArray
                            this.menus.push(nodeElement)
                        }
                    }
                }

                // honor explicit `order` on top-level items so the Procedures group lands at order 4
                this.menus.sort((a, b) => (a.order ?? 100) - (b.order ?? 100))
            },
            onScroll() {
                // Check scroll position and toggle app bars
                this.scrolled = window.scrollY > 50 // Adjust threshold as needed
            },
            changeLanguage(language) {

                clearTranslation()

                this.changingLanguage = true
                UsersService.changeLanguage(language).then((res) => {

                    this.$store.dispatch('user/setUserSession', res.data)
                    this.$store.dispatch('user/setLanguage', language)
                    window.location.href = '/'

                }).catch(() => {

                }).finally(() => {
                    this.changingLanguage = false
                })
            },

            downloadGuide() {
                AttachmentsService.getUserGuide().then((res) => {
                    openFile(res.data)
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                })
            },

            loadNotifications() {
                UsersService.countUnclaimedTasks().then(res => {
                    this.messages = res.data || 0
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            // "Unread" is the same state the badge counts: an activity nobody has claimed yet.
            // Tasks.vue claims one the moment it opens it, so a task read there drops out of
            // this list on the next open.
            loadUnreadTasks() {
                this.loadingNotifications = true
                TasksService.listTasks(1, this.notificationsPageSize).then(res => {
                    const rows = res.data && res.data.data ? res.data.data : []
                    this.notifications = rows.filter(task => !task.claimed)
                }).catch(() => {
                    this.notifications = []
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loadingNotifications = false
                })
            },

            openNotification(item) {
                if (!item.claimed) {
                    this.markNotificationRead(item)
                }
                this.notificationsMenu = false

                const taskId = String(item.activityInstanceId)
                if (this.$route.path === '/tasks' && this.$route.query.taskId === taskId) {
                    return
                }
                this.$router.push({ path: '/tasks', query: { taskId } }).catch(() => { })
            },

            // Claiming an activity is what marks it read — the badge counts activities with no
            // claim. This used to be left to the tasks page, but that leaves the notification
            // unread whenever the page does not remount (a second click while already on
            // /tasks), so the click handler now owns it. ClaimAsync is a no-op once an activity
            // is claimed, so the tasks page claiming it again on open costs nothing.
            markNotificationRead(item) {
                this.$set(item, 'claimed', true)
                this.messages = Math.max(0, this.messages - 1)

                TasksService.claimActivity(item.activityInstanceId).then(() => {
                    // reconcile against the server rather than trust the optimistic -1
                    this.loadNotifications()
                }).catch(() => {
                    this.$set(item, 'claimed', false)
                    this.loadNotifications()
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                })
            },

            // translate with a built-in fallback, so the label still reads correctly when the
            // key has not been added to the translations table yet
            tr(key, fallbackEn, fallbackAr) {
                if (this.$te(key)) {
                    return this.$t(key)
                }
                return this.isArabicLanguage ? fallbackAr : fallbackEn
            },

            logout() {
                this.$router.push({ name: 'logout' })
            }
        }
    }
</script>
<style>
    /* Notifications dropdown: rows mirror the task tiles on the Tasks page */
    .hdr-menu--notif { width: 380px; max-width: calc(100vw - 24px); max-height: calc(100vh - 90px) !important; overflow-y: auto; }
    .hdr-badge ::v-deep .v-badge__badge, .hdr-badge .v-badge__badge {
        font-size: 10.5px; font-weight: 700; min-width: 18px; height: 18px; padding: 2px 5px; border-radius: 999px;
        box-shadow: 0 0 0 2px #F3F4F6;
    }
    .ntf { background: #fff; }
    .ntf-head {
        display: flex; align-items: center; gap: 10px;
        padding: 12px 16px; border-bottom: 1px solid #e6ecea; position: sticky; top: 0; z-index: 1; background: #fff;
    }
    .ntf-head-ic {
        display: inline-flex; align-items: center; justify-content: center;
        width: 30px; height: 30px; border-radius: 9px; background: #e6f2f1;
    }
    .ntf-head-ic .v-icon { color: #0a716e !important; }
    .ntf-title { font-size: 14.5px; font-weight: 800; color: #1f2a28; }
    .ntf-count {
        margin-inline-start: auto; min-width: 24px; height: 22px; padding: 0 8px;
        display: inline-flex; align-items: center; justify-content: center;
        border-radius: 999px; background: #0a716e; color: #fff; font-size: 11.5px; font-weight: 700;
    }
    .ntf-list {
        overflow: visible;
        display: flex; flex-direction: column; gap: 6px; padding: 8px;
    }
    .ntf-item {
        position: relative; display: flex; flex-direction: column; gap: 4px;
        width: 100%; text-align: start; padding: 10px 12px;
        border: 1px solid transparent; border-radius: 12px; background: #f3f6f5;
        color: #1f2a28; font: inherit; cursor: pointer;
        transition: background-color .18s ease, border-color .18s ease;
        -webkit-tap-highlight-color: transparent;
    }
    .ntf-item:hover { background: #eef3f2; }
    .ntf-item:focus { outline: none; }
    .ntf-item:focus-visible { border-color: #0a716e; }
    .ntf-item:not(.is-unread) { background: #fff; border-color: #eef2f1; }
    .ntf-item:not(.is-unread) .ntf-item-title { font-weight: 600; color: #4a5553; }
    .ntf-bar {
        position: absolute; inset-inline-start: 0; top: 10px; bottom: 10px; width: 3px; border-radius: 3px;
        background: transparent;
    }
    .ntf-item.is-unread .ntf-bar { background: #0a716e; }
    .ntf-item.is-late .ntf-bar { background: #dc2626; }
    .ntf-top { display: flex; align-items: flex-start; justify-content: space-between; gap: 8px; }
    .ntf-item-title { font-size: 13.5px; font-weight: 800; line-height: 1.35; }
    .ntf-ref {
        flex: 0 0 auto; font-size: 11px; font-weight: 700; color: #0a716e; background: #e6f2f1;
        padding: 2px 8px; border-radius: 999px;
    }
    .ntf-process { font-size: 12px; color: #6b7a77; line-height: 1.45; }
    .ntf-req { font-size: 12px; font-weight: 600; color: #1f2a28; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .ntf-meta { display: flex; align-items: center; gap: 5px; margin-top: 2px; font-size: 11.5px; color: #6b7a77; }
    .ntf-meta-ic { color: #9aa8a5 !important; }
    .ntf-item.is-late .ntf-meta, .ntf-item.is-late .ntf-meta-ic { color: #dc2626 !important; }
    .ntf-date { font-variant-numeric: tabular-nums; }
    .ntf-empty {
        display: flex; flex-direction: column; align-items: center; gap: 8px;
        padding: 30px 16px; color: #6b7a77; font-size: 13px; font-weight: 600;
    }

    /* Header dropdowns (language, account) and their trigger buttons */
    .v-btn.hdr-btn {
        border-radius: 12px !important;
        min-width: 40px !important;
        height: 38px !important;
        padding: 0 10px !important;
        text-transform: none;
        letter-spacing: 0;
        font-weight: 600;
        background: transparent !important;
    }
    .v-btn.hdr-btn::before { background-color: #e6f2f1 !important; border-radius: 12px; }
    .v-btn.hdr-btn:hover .v-btn__content,
    .v-btn.hdr-btn:focus .v-btn__content,
    .v-btn.hdr-btn[aria-expanded="true"] .v-btn__content { color: #0a716e !important; }
    .v-btn.hdr-btn:hover .v-icon,
    .v-btn.hdr-btn:focus .v-icon,
    .v-btn.hdr-btn[aria-expanded="true"] .v-icon { color: #0a716e !important; }

    .hdr-btn-label { margin-inline-start: 6px; }
    /* on any dashboard route the shortcut stays highlighted */
    .v-btn.hdr-btn--dashboard.v-btn--active { background: #e6f2f1 !important; }
    .v-btn.hdr-btn--dashboard.v-btn--active::before { opacity: 0 !important; }
    .v-btn.hdr-btn--dashboard.v-btn--active .v-btn__content,
    .v-btn.hdr-btn--dashboard.v-btn--active .v-icon { color: #0a716e !important; }
    @media (max-width: 600px) {
        .hdr-btn--dashboard .hdr-btn-label { display: none; }
    }

    .hdr-menu {
        min-width: 220px !important;
        border-radius: 16px !important;
        border: 1px solid #e6ecea;
        background: #fff;
        box-shadow: 0 1px 2px rgba(15, 23, 42, .05), 0 18px 40px -18px rgba(15, 23, 42, .35) !important;
        overflow: hidden;
    }
    .hdr-menu--account { min-width: 280px !important; }

    .hdr-list { padding: 6px !important; background: #fff !important; }
    .hdr-item {
        min-height: 40px !important;
        border-radius: 10px;
        padding: 0 10px !important;
        gap: 10px;
        transition: background-color .15s ease;
    }
    .hdr-item:hover, .hdr-item:focus-within { background: #f3f6f5; }
    .hdr-item::before { display: none; }
    .hdr-item-ic {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 30px;
        width: 30px;
        height: 30px;
        border-radius: 9px;
        background: #f3f6f5;
    }
    .hdr-item-ic .v-icon { color: #6b7a77 !important; }
    .hdr-item:hover .hdr-item-ic { background: #e6f2f1; }
    .hdr-item:hover .hdr-item-ic .v-icon { color: #0a716e !important; }
    .hdr-item-title { font-size: 13.5px !important; font-weight: 600; color: #1f2a28; }
    .hdr-item-check { color: #0a716e !important; margin-inline-start: auto; }
    .hdr-item.is-current .hdr-item-title { color: #0a716e; font-weight: 700; }
    .hdr-item.is-current .hdr-item-ic { background: #e6f2f1; }
    .hdr-item.is-current .hdr-item-ic .v-icon { color: #0a716e !important; }
    .hdr-item--danger .hdr-item-title { color: #b91c1c; }
    .hdr-item--danger .hdr-item-ic .v-icon { color: #b91c1c !important; }
    .hdr-item--danger:hover { background: #fef2f2; }
    .hdr-item--danger:hover .hdr-item-ic { background: #fee2e2; }
    .hdr-item--danger:hover .hdr-item-ic .v-icon { color: #b91c1c !important; }
    .hdr-sep { height: 1px; margin: 6px 8px; background: #e6ecea; }

    .hdr-account {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 14px 16px;
        background: #f8faf9;
        border-bottom: 1px solid #e6ecea;
    }
    .hdr-avatar {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 44px;
        width: 44px;
        height: 44px;
        border-radius: 14px;
        background: #0a716e;
    }
    .hdr-avatar .v-icon { color: #fff !important; }
    .hdr-account-body { display: flex; flex-direction: column; min-width: 0; }
    .hdr-account-name { font-size: 15px; font-weight: 800; color: #1f2a28; line-height: 1.3; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .hdr-account-mail { font-size: 12px; color: #6b7a77; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; direction: ltr; text-align: start; }

    ul.top-header-menu * {
        color: #dedede;
    }
    ul.top-header-menu li {
        display: inline-block;
        padding:0 15px
    }

    li.dot {
        width: 6px;
        height: 6px;
        background: #ffffff54;
        border-radius: 50px !important;
        padding:0px !important
    }

    ul.top-header-menu li .dropdown-item {
        display: block;
        width: 100%;
        padding: 5px;
        color:#384250;
        font-weight: 400;
        font-size: .85rem;
        text-align: inherit;
        white-space: nowrap;
        text-decoration: none;
    }
    ul.top-header-menu li:first-child .dropdown-item {
        padding: 5px;
        background: #7fbe41;
        border-radius: 6px !important;
    }
    .v-btn.menubtn{
        font-size: 0.65vw !important;
        padding:0px !important;
        font-weight: 600;
        height: 45px!important;
    }
    .logolink{
        height:auto
    }
    .logolink::before, .logolink:hover::before{
        opacity:0 !important
    }
    .v-btn.menubtn:not(.v-btn--round).v-size--default {
        position: relative;
        height: 100%!important;
    }
    .v-btn--active.menubtn::after {
        content: "";
        height: 7px;
        border-radius: 20px;
        width: 80%;
        
        bottom: 0;
        background-color: #54C08A;
        position: absolute;
        z-index: 9999;

    }
    .v-btn.menubtn:before {
        background-color: #1B8354!important;
    }
    .theme--light.v-btn--active.logolink::before, .theme--light.v-btn--active.logolink:hover::before {
        opacity: 0!important;
    }
    .v-ripple__container {
        background-color: transparent;
    }
    .theme--light.v-btn:focus::before, .theme--light.v-btn:hover::before, .theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
        opacity: 1!important;
    }
    .v-btn__content {
        padding: 0 5px;
    }
 
    .theme--light.v-btn:focus .v-btn__content, .theme--light.v-btn:hover .v-btn__content, .theme--light.v-btn--active:hover .v-btn__content, .theme--light.v-btn--active .v-btn__content {
        color: #FFF;
    }
    .v-btn--active.logolink:before, .v-btn.logolink:before {
background-color: transparent!important;
    }
    
</style>